import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnCreateMenu = generator('onCreateMenu');
const HPMSOnCreateOption = generator('onCreateOption');
const HPMSOnOptionClick = generator('onOptionClick');
const HPMSOnRenderAction = generator('onRenderAction');
const HPMSOnOpen = generator('onOpen');

export {
  HPMSOnCreateMenu,
  HPMSOnCreateOption,
  HPMSOnOptionClick,
  HPMSOnRenderAction,
  HPMSOnOpen,
};
